import { FormGroup, ValidatorFn } from '@angular/forms';

export class CheckboxValidators {

  static haveOneChecked(): ValidatorFn {
    return (formGroup: FormGroup): { [key: string]: boolean } | null => {
      let valid = false;

      for (let control in formGroup.controls) {
        if (formGroup.controls[control].value === true) {
          valid = true;
          break;
        }
      }

      return valid === true ? null : { 'nochecked': true };
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/validators/checkbox.validator.ts